<!-- 文章详情页 -->
<template>
  <div class="design_del">
    <!--left  文章详情-->
    <div class="design_left">
      <div class="design_content_left">
        <div class="title_box">
          <p class="title">{{acticleDel.Name}}</p>
          <p class="time">{{acticleDel.CreationTimeShow}}发布</p>
          <p class="classify">{{acticleDel.FirstCategory}}/{{acticleDel.LastCategory}}</p>
        </div>
        <p class="ql-editor design_content " v-html="acticleDel.Content"></p>
        <button class="thumbs_btn" @click="thumbsClick" :class="[hasLike?'thumbsed':'']">
          <i class="icon_thumbs"></i>
          <p>{{LikeNumbers}}</p>
        </button>
        <!--下载源文件  -->
        <div class="down_con" v-show="hasFileDown">
          <a @click="fileDown">下载源文件</a>
        </div>
      </div>

      <comment :SourceID="id" Type="2" @totalCount="totalCount"></comment>
    </div>
    <!--right  用户信息-->
    <div class="design_right">
      <div class="user_info">
         <router-link tag="div" :to="acticleDel.UserId!=userId?'/personInfo/original?uid='+acticleDel.UserId:'/homepage'"> 
        <img class="user_header" :src="userMessage.Avatar" />
        <p class="user">{{userMessage.JobNo}} {{userMessage.NickName}}</p>
        </router-link>
        <p class="icon_box">
          <span class="icon">
            <i class="icon_comment"></i>{{userMessage.WordsNumbers}}</span>
          <span>
            <i class="icon_thumbs1"></i>{{userMessage.LikeNumbers}}</span>
        </p>
      </div>
      <div class="user_acticle">
        <div class="acticle_box clearfix">
          <span class="fl user_txt">TA的作品</span>
          <p class="fr acitcle_num">已有
            <span class="c333">{{userMessage.WorksNumbers}}</span>件作品</p>
        </div>
        <ul class="acitcle_list">
          <li v-for="(act,index) in userMessage.Works" :key="act.Id">
            <img :src="act.CoverImage" />
          </li>
        </ul>
      </div>
    </div>
    <login :isShow="logShow" :bgShow="false" @close="logClose"></login>
  </div>
</template>

<script>
import { getArticleDel, getThumbsDel, downFileFirst } from "../../assets/js/modules/articleApi"
import login from "../common/login"
import Comment from "../common/comment"
export default {
  props: {
    id: { //文章id
    },
    sourceType: {
    }
  },
  components: {
    login,
    Comment
  },
  data() {
    return {
      userId: "",
      acticleDel: {}, //文章详情
      userMessage: {},//用户信息
      LikeNumbers: "",//点赞数
      hasLike: false, //是否点赞
      hasFileDown: "",//是否有下载原文件
      baseUrl: process.env.BASE_API, //接口地址
      logShow: false
    };
  },
  created() {
    this.getUserInfo();

  },
  mounted() {
    let data = {
      UserId: this.userId,
      Id: this.id
    }
    getArticleDel(data).then(res => {//文章详情
      // console.log(res.data.Data) 
      if (res.data.Success) {
        this.acticleDel = res.data.Data.Article;
        this.LikeNumbers = res.data.Data.LikeNumbers;
        this.userMessage = res.data.Data.UserInfo;
        if (this.acticleDel.HasDesignSourceFile) {
          this.hasFileDown = true;
        } else {
          this.hasFileDown = false;
        }
        if (JSON.parse(localStorage.getItem('userInfo'))) {
          this.hasLike = res.data.Data.HasLike;
        } else {
          this.hasLike = false;
        }
      }
    })
  },
  methods: {
    thumbsClick() { //post点赞
      if (JSON.parse(localStorage.getItem('userInfo'))) {
        this.logShow = false;
        if (!this.hasLike) {
          this.LikeNumbers += 1;
          this.hasLike = true;
          this.userMessage.LikeNumbers += 1;
          let data = { //获取点赞数参数
            SourceID: this.acticleDel.Id, //文章ID
            UserID: this.userId, //用户ID
            SourceType: 2, //综合类型(1：文件、2：文章、3：评论)
            Type: 1 //类型(1、点赞、2、收藏、3、下载、4：浏览数)
          }
          getThumbsDel(data).then(res => {
            console.log("成功")
          })
        } else {
          return;
        }
      } else {
        this.logShow = true;
      }

    },
    fileDown() { //下载源文件
      let down = {
        FileId: this.acticleDel.Id,
        FileDetailType: 5 //（1使用文件  2使用规范文件  3输出文件  4授权文件  5设计交流源文件)
      };
      downFileFirst(down).then(res => {
        if (res.data.Code == 1) {
          let url = process.env.BASE_API+"/api/UpLoadFile/DownloadSecondAsync?Identity=" +res.data.Data;
          window.location.href = url;
        }else {
          this.$warn({
            warnText: '您的账户没有权限，熊出没相关资料需24级以上账户方可下载',
            isShow: true
          });
        }
      })
    },
    getUserInfo() { //获取用户信息
      if (JSON.parse(localStorage.getItem('userInfo'))) {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.userId = this.userInfo.Id;
      } else {
        this.userId = "";
      }
    },
    logClose() {
      this.logShow = false;
    },
    totalCount(data) {
      if (data) {
        this.userMessage.WordsNumbers++;
      } else {
        this.userMessage.WordsNumbers--;
      }

    }
  }
}

</script>
<style  scoped>
* {
  box-sizing: border-box;
}

.c333 {
  color: #333;
}

.design_del>>>img {
  display: block;
  max-width: 100%;
  /* margin: 0 auto; */
}

.design_del {
  width: 100%;
  max-width: 1280px;
  margin: 50px auto;
  display: flex;
  justify-content: space-between;
}

.design_left {
  width: 950px;
}

.design_content_left {
  width: 100%;
  background: #fff;
  padding: 28px 0;
  border: 1px solid #e7e7e7;
  border-radius: 10px;
}

.title_box {
  border-bottom: 1px solid #e7e7e7;
  padding: 0 0 24px;
  margin: 0 38px 20px;
}

.design_content {
  height: auto;
  margin: 0 38px;
}

.design_left .title {
  font-size: 22px;
  color: #666;
}

.design_left .time {
  font-size: 14px;
  color: #999;
  margin-top: 20px;
}

.design_left .classify {
  font-size: 14px;
  color: #999;
  margin-top: 14px;
}

.thumbs_btn {
  width: 64px;
  height: 64px;
  background: #ff9a35;
  border-radius: 50px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  display: block;
  margin: 30px auto 24px;
}

.thumbs_btn.thumbsed {
  background: #d1d1d1;
}

.thumbs_btn:hover {
  background: #ffb164;
}

.thumbs_btn.thumbsed:hover {
  background: #d1d1d1;
}

.icon_thumbs {
  width: 23px;
  height: 23px;
  display: inline-block;
  background: url("../../assets/img/icon_zan.png") no-repeat;
  margin-top: 6px;
}

.down_con {
  border-top: 1px solid #efefef;
  overflow: hidden;
}

.down_con a {
  font-size: 14px;
  color: #999;
  text-align: center;
  width: 100px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  float: right;
  border: 2px solid #ffbb77;
  border-radius: 20px;
  margin-top: 16px;
  margin-right: 40px;
  cursor: pointer;
}

.design_right {
  width: 302px;
  /* background: #fff;
  border-radius: 18px;
  border: 1px solid #e7e7e7; */
}

.user_info {
  font-size: 12px;
  color: #666;
  height: 255px;
  padding: 35px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e7e7e7;
  text-align: center;
}

.user_info .user {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 22px;
  margin-top: 22px;
  cursor: pointer;
}

.user_header {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 0 auto;
  cursor: pointer;
}

.user_info .icon_box {
  color: #ccc;
  margin-top: 28px;
}

.icon_box .icon {
  margin-right: 20px;
}

.icon_comment {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../../assets/img/icon_comment.png") no-repeat;
  position: relative;
  top: 4px;
  margin-right: 5px;
}

.icon_thumbs1 {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../../assets/img/icon_thumbs.png") no-repeat;
  position: relative;
  top: 4px;
  margin-right: 5px;
}

.user_acticle {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e7e7e7;
  margin-top: 24px;
}

.user_acticle .acticle_box {
  height: 46px;
  line-height: 46px;
  border-bottom: 1px solid #e7e7e7;
  margin: 0 35px;
}

.user_txt {
  font-size: 16px;
  color: #333;
}

.acitcle_num {
  font-size: 14px;
  color: #999;
}

.acitcle_list {
  margin: 0 20px;
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.acitcle_list li {
  width: 126px;
  margin-top: 12px;
}

.acitcle_list li img {
  width: 100%;
  height: 95px;
  object-fit: cover;
}

.design_content>>>.ql-video{
  width: 100%;
  height: 472px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/designDel.vue